import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup} from "@angular/forms";
import { EvkOption } from '@evomatik/evk-common';
import { BehaviorSubject, Observable, Subject, combineLatest, forkJoin, of } from 'rxjs';
import { CatalogosService } from '../../../../services/catalogos.service';
import { filter, map, startWith } from 'rxjs/operators';

@Component({
    selector: 'lib-datos-entrega',
    templateUrl: './datos-entrega.component.html',
    styleUrls: ['./datos-entrega.component.css']
})
export class DatosEntregaComponent implements OnInit {
    @Input()
    form: FormGroup;

    periodicidadOptions: EvkOption[] = [];
    dependenciaOptions: EvkOption[] = [];
    periodicidadFilteredOptions$: Observable<EvkOption[]>;
    dependenciaFilteredOptions$: Observable<EvkOption[]>;
    catalogosCargados: EventEmitter<boolean> = new EventEmitter();

    constructor(public catalogoService: CatalogosService) {
    }

    ngOnInit(): void {
        this.cargaCatalogos();
        this.eventHandlerEventInit();
    }


    cargaCatalogos() {
        const requests = [];
        requests.push(this.catalogoService.getByDiscriminatorSimpleOptions('PERIODICIDAD'));
        requests.push(this.catalogoService.getDependenciasChihuahua());
        forkJoin(requests).subscribe((
            [res1, res2]: [EvkOption[], EvkOption[]]
        ) => {
            this.periodicidadOptions = res1;
            this.dependenciaOptions = res2;
            this.catalogosCargados.emit(true);
        });
    }

    eventHandlerEventInit() {
        this.catalogosCargados.subscribe((res) => {
            if (res) {
                this.periodicidadFilteredOptions$ = this.filterOptions(this.form.controls.a4Periodicidad, of(this.periodicidadOptions));
                this.dependenciaFilteredOptions$ = this.filterOptions(this.form.controls.a4Dependencia, of(this.dependenciaOptions));
            }
        });
        this.form.controls.a4FechaEntrega.setValue(this.form.controls.a4FechaEntrega?.value);
    }

    filterOptions = (formControl: FormControl | AbstractControl, opciones$: Observable<EvkOption[]>, valueChanges?: Observable<any> | Subject<any> | BehaviorSubject<any>) => {
        const valueChanges$ = valueChanges ? valueChanges : formControl.valueChanges;
        return combineLatest(
            [
                valueChanges$.pipe(startWith('')),
                opciones$
            ]
        ).pipe(
            filter(([value, _]) => typeof value === 'string'
            ),
            map(([name, opciones]) => name ? this._filter(name, opciones) : opciones.slice())
        );

    }

    _filter(label: any, options: EvkOption[]): EvkOption[] {
        const filterValue = this.removeAccents(label.toLowerCase());
        return options.filter(
            option =>
                this.removeAccents(option.label.toLowerCase()).indexOf(filterValue) !== -1);
    }

    removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    displayFn = (option) => (option && option.label) ? option.label : '';

    dateChange = (event: any) => {
        const date = event.target.value;
        this.form.controls.a4FechaEntrega.setValue(date);
    }
}
